<template>
    <div class="c-header-panel c-header-vip" id="c-header-vip">
        <el-tooltip effect="dark" content="会员中心" placement="bottom" popper-class="c-header-tooltip">
            <a class="u-post u-vip" href="/vip/premium">
                <i class="u-icon u-icon-msg">
                    <i class="u-pop" style="display: none" v-show="pop"></i>
                    <svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" v-bind:class="'u-add'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M173.88 38.05H66.12a23.59 23.59 0 00-20 11.28l-35.31 58.12L120 215.86l109.19-108.41-35.27-58.12a23.59 23.59 0 00-20.04-11.28zM120 196.14l-91.5-90.85 29.55-48.7a9.5 9.5 0 018.07-4.54h107.76a9.5 9.5 0 018.12 4.54l29.55 48.7z"/><path d="M127.67 145.92a10.45 10.45 0 01-14.76 0l-36.75-36.75-8.48 8.48 36.74 36.75a22.48 22.48 0 0031.74 0l37-37-8.49-8.48z"/></svg>
                </i>
            </a>
        </el-tooltip>
    </div>
</template>

<script>
import { getConfig, getUserMeta, setUserMeta } from "../../service/cms";
import User from "@jx3box/jx3box-common/js/user";
export default {
    name: "vip",
    data: function () {
        return {
            pop: false
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            /**
             * 1. 用户第一次进入页面时，没有记录，则显示，并记录到meta
             * 2. 用户第二次进入页面，此时meta有记录，但是用户并未进入会员中心，则显示
             */
            let meta = null
            if (User.isLogin()) {
                meta = await getUserMeta({ key: "vip_pop" });
            }
            let config = await getConfig({ key: "vip" });


            if (meta == null) {
                const val = ~~config.val;

                if (val) {
                    this.pop = true;
                    localStorage.setItem('vip_pop', config.val);
                    setUserMeta("vip_pop", { val: 1 });
                }
            } else {
                if (meta == 1) {
                    this.pop = true;

                    localStorage.setItem('vip_pop', config.val);
                } else {
                    const local = localStorage.getItem('vip_pop');

                    if (~~config.val > ~~local) {
                        this.pop = true;

                        localStorage.setItem('vip_pop', config.val);

                        // setUserMeta("vip_pop", { val: 1 });
                    }
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.c-header-vip {
    height: 100%;

    .u-icon-msg {
        .pr;
        .size(18px);
    }

    .u-pop {
        width: 10px;
        height: 10px;
        color: #fff;
        background-image: linear-gradient(#54a3ff, #006eed);
        background-clip: padding-box;
        border: 2px solid #24292e;
        border-radius: 50%;
        position: absolute;
        right: -5px;
        top: -6px;
        z-index: 1;
    }
    .u-vip {
        padding: 0 10px;
        height: 100%;
        .flex;
        align-items: center;

        &:hover {
            opacity: 0.7;
        }
        cursor: pointer;
    }
}
</style>
